<section *ngIf="processing">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div *ngIf="!processing" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>construction</mat-icon> Bulk Operation
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button type="submit" (click)="onSubmit()" mat-raised-button color="primary" title="Submit" [disabled]="processing || bulkForm.get('operation').value == ''" >Submit</button>
    &nbsp;&nbsp;
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic"
      title="Close">Close</button>
  </div>
</div>
<mat-dialog-content>
  <div *ngIf="!processing">
    <form #form="ngForm" [formGroup]="bulkForm" class="form-field-full">
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start"><br /></div> 
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">Total Records:{{bulkOperation.ids.length}}</div>
    <!-- bulk options -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">        
        <mat-form-field appearance="standard">
          <mat-label>Operation:</mat-label>
          <mat-select id="operation" name="operation" formControlName="operation">
              <mat-option value=""></mat-option>
              <mat-option value="Copy">Bulk Copy</mat-option>
              <mat-option value="Update">Bulk Update</mat-option>
              <mat-option value="Delete">Bulk Delete</mat-option>
          </mat-select>
      </mat-form-field>
      </div>    
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">  
        <p [hidden]="bulkForm.get('operation').value !== 'Copy'" >
          This operation will bulk copy all <strong>{{bulkOperation.ids.length}}</strong> record(s) and set the values below.  Any value left blank will not override the original value.<br /><br />
          <strong>NOTE:</strong> The options below are carried over from your search criteria and MUST be updated to your desired settings.
        </p> 
        <p [hidden]="bulkForm.get('operation').value !== 'Update'" >
          This operation will bulk update all <strong>{{bulkOperation.ids.length}}</strong> record(s) and set the values below.  Any value left blank will not override the original value.<br /><br />
          <strong>NOTE:</strong> The options below are carried over from your search criteria and <strong>MUST</strong> be updated to your desired settings.
        </p>
        <p [hidden]="bulkForm.get('operation').value !== 'Delete'" >
          This operation will bulk delete all {{bulkOperation.ids.length}} record(s).
        </p>
      </div>     
    </div>

    <!-- Status -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" [hidden]="bulkForm.get('operation').value !== 'Copy' && bulkForm.get('operation').value !== 'Update'">
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">        
        <mat-form-field appearance="standard">
          <mat-label>Status</mat-label>
          <mat-select id="status" name="status" formControlName="status">
              <mat-option value=""></mat-option>
              <mat-option value="Yes">Completed</mat-option>
              <mat-option value="No">Not Completed</mat-option>
              <mat-option value="Incomplete">Incomplete/Expired</mat-option>
          </mat-select>
      </mat-form-field>
      </div>      
    </div>

    <!--Year, Tier, & Quarter -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" [hidden]="bulkForm.get('operation').value !== 'Copy' && bulkForm.get('operation').value !== 'Update'">
      <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">   
        <mat-form-field appearance="standard">
            <mat-label>Year</mat-label>
            <mat-select id="year" name="year" formControlName="year">
                <mat-option value="0"></mat-option>
                <mat-option *ngFor="let item of retestService.retestYears" [value]="item.id">{{item.id}}</mat-option>
            </mat-select>
        </mat-form-field>
      </div> 
      <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">   
        <mat-form-field appearance="standard">
          <mat-label>Quarter</mat-label>
          <mat-select id="quarter" name="quarter" formControlName="quarter">
              <mat-option value="0"></mat-option>
              <mat-option *ngFor="let item of retestService.retestQuarters" [value]="item.id">
                  Quarter {{item.id}} (Q{{item.id}})
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">   
        <mat-form-field appearance="standard">
          <mat-label>Tier</mat-label>
          <mat-select id="tier" name="tier" formControlName="tier">
              <mat-option value="0"></mat-option>
              <mat-option *ngFor="let item of retestService.tiers" [value]="item.id">Tier {{item.id}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>   
    </div>
    <!-- due by -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" [hidden]="bulkForm.get('operation').value !== 'Copy' && bulkForm.get('operation').value !== 'Update'">
      <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">        
        <mat-form-field appearance="standard">
          <mat-label>Due By</mat-label>
          <input id="dueBy" name="dueBy" formControlName="dueBy" matInput [matDatepicker]="dueByPicker" placeholder="Choose a due by date">
          <mat-datepicker-toggle matSuffix [for]="dueByPicker"></mat-datepicker-toggle>
          <mat-datepicker #dueByPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
 
  </form> 
  </div>
  
</mat-dialog-content>